import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid, MenuItem, Select, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";
import verified from "assets/images/verified.png";
import pending from "assets/images/load.png";

export default class LevelQuestions extends Component {
  state = {
    allJobs: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    noticolor: "success",
    per_page: 20,
    page_no: 1,
    redirect: false,
    level_id: "",
    levelDetails: null,
    filters: {
      approved_status: "",
      qType: "",
      search: "",
    },
  };

  componentDidMount() {
    const level_id = window.location.pathname.split("/")[2];
    this.setState({ level_id }, () => {
      this.getLevelDetails();
      this.getAllQuestions(this.state.page_no, this.state.per_page);
    });
  }

  getLevelDetails = async () => {
    try {
      if (init() === "success" && this.state.level_id) {
        const resp = await axios.get(`${Constants.getUrls.getAllLevels}/${this.state.level_id}`);
        if (resp?.data?.status === "success") {
          this.setState({ levelDetails: resp.data.data });
        }
      }
    } catch (err) {
      this.setState({
        notification: true,
        noticolor: "error",
        message: err?.response?.data?.message || "Unable to fetch level details",
      });
    }
  };

  getAllQuestions = (page = 1, limit = this.state.per_page) => {
    try {
      if (init() === "success") {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
          level_id: this.state.level_id,
        });

        const { approved_status, qType, search } = this.state.filters;
        if (approved_status) params.append("approved_status", approved_status);
        if (qType) params.append("qType", qType);
        if (search) params.append("search", search);

        axios
          .get(`${Constants.getUrls.getAllQuestions}?${params.toString()}`)
          .then((resp) => {
            if (resp.data.status === "success") {
              this.setState({
                allJobs: resp.data.data.docs,
                pagination: resp.data.data,
                page_no: resp.data.data.page,
              });
            } else {
              this.setState({
                notification: true,
                noticolor: "error",
                message: resp.data.message,
              });
            }
          })
          .catch((err) => {
            this.setState({
              notification: true,
              noticolor: "error",
              message: err.response?.data?.message || "Error fetching questions",
            });
          });
      } else {
        this.setState({ redirect: true });
      }
    } catch (err) {
      this.setState({
        notification: true,
        noticolor: "error",
        message: "Error fetching questions",
      });
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllQuestions(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllQuestions(newPage, this.state.per_page);
  };

  handleFilterInput = (name, value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }));
  };

  applyFilters = () => {
    this.getAllQuestions(1, this.state.per_page);
  };

  resetFilters = () => {
    this.setState(
      {
        filters: {
          approved_status: "",
          qType: "",
          search: "",
        },
      },
      () => this.getAllQuestions(1, this.state.per_page)
    );
  };

  render() {
    const { levelDetails, allJobs, pagination } = this.state;

    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    }

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Level Wise Questions
                </MDTypography>
                <MDTypography variant="button" color="white" opacity={0.9}>
                  {levelDetails
                    ? `${levelDetails.level_name} | ${levelDetails.level_type} practice set`
                    : "Loading level details..."}
                </MDTypography>
              </MDBox>

              <Grid container spacing={2} px={2} pt={3}>
                <Grid item xs={12} md={4}>
                  <MDTypography variant="button" fontWeight="medium">
                    Subject
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    {levelDetails?.subject_id?.subject_name || "-"}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MDTypography variant="button" fontWeight="medium">
                    Topic
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    {levelDetails?.topic_id?.topic_name || "-"}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} md={4} style={{ textAlign: "right" }}>
                  <Link to="/levels">
                    <MDButton variant="outlined" size="small" color="info">
                      Back to Levels
                    </MDButton>
                  </Link>
                </Grid>
              </Grid>

              <Grid container spacing={2} px={2} pt={3} pb={1}>
                <Grid item xs={12} md={3}>
                  <Select
                    fullWidth
                    displayEmpty
                    value={this.state.filters.approved_status}
                    onChange={(e) => this.handleFilterInput("approved_status", e.target.value)}
                  >
                    <MenuItem value="">All Status</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Select
                    fullWidth
                    displayEmpty
                    value={this.state.filters.qType}
                    onChange={(e) => this.handleFilterInput("qType", e.target.value)}
                  >
                    <MenuItem value="">All Question Types</MenuItem>
                    <MenuItem value="easy">Easy</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="hard">Hard</MenuItem>
                    <MenuItem value="medium-hard">Medium-Hard</MenuItem>
                    <MenuItem value="hardest">Hardest</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    placeholder="Search question text"
                    value={this.state.filters.search}
                    onChange={(e) => this.handleFilterInput("search", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={2} style={{ display: "flex", gap: "8px" }}>
                  <MDButton variant="contained" color="info" onClick={this.applyFilters}>
                    Search
                  </MDButton>
                  <MDButton variant="outlined" color="secondary" onClick={this.resetFilters}>
                    Reset
                  </MDButton>
                </Grid>
              </Grid>

              <MDBox>
                <DataTable
                  table={{
                    columns: [
                      { Header: "serial", accessor: "serial", width: "6%" },
                      { Header: "question", accessor: "question" },
                      { Header: "type", accessor: "type" },
                      { Header: "status", accessor: "status" },
                      { Header: "action", accessor: "action" },
                    ],
                    rows: allJobs.map((job, index) => ({
                      serial: (this.state.page_no - 1) * this.state.per_page + index + 1,
                      question: job.question,
                      type: job.question_type,
                      status:
                        job.approved_status === "approved" ? (
                          <img src={verified} height="28px" alt="approved" />
                        ) : (
                          <img src={pending} height="28px" alt="pending" />
                        ),
                      action: (
                        <Link to={`/updateQuestion/${job._id}`}>
                          <MDButton variant="outlined" size="small" color="success">
                            Update
                          </MDButton>
                        </Link>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                  page_no={pagination?.page}
                  totalPages={pagination?.totalPages}
                  hasNextPage={pagination?.hasNextPage}
                  hasPrevPage={pagination?.hasPrevPage}
                  isnextPage={pagination?.nextPage}
                  prevPage={pagination?.prevPage}
                  totalDocs={pagination?.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              </MDBox>

              <MDSnackbar
                color={this.state.noticolor}
                icon="notifications"
                title="AgriQuiz"
                content={this.state.message}
                dateTime="Just now"
                open={this.state.notification}
              />
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
